/* eslint-disable no-console */
import * as smoothscroll from 'smoothscroll-polyfill'

import React from 'react'
import ReactDOM from 'react-dom'

import App from '~/components/App'

import theme from '~/theme'

import { Sentry } from '~/clients/sentry'
import checkIfHasDeprecatedStorage from '~/utils/checkIfHasDeprecatedStorage'
import { dorisLog } from '~/utils/dorisLog'
import DorisStartEvent from '~/utils/dorisStartEvent'
import { fetchUrlParameters } from '~/utils/fetchSkuWithUrlParameters'
import { handleABTests } from '~/utils/handleABTests'
import { HandleGoToCartInstance } from '~/utils/handleGoToCart'
import { injectButton } from '~/utils/injectButton'
import { captureOrderEvent } from '~/utils/orderEvent'
import { validationsDataOrder } from '~/utils/orderEvent/validations'
import Tracking from '~/utils/tracking'
import { validateAndParseLanguage } from '~/utils/translate'
import { verify } from '~/utils/verify'

import { EOrigin } from './utils/dorisStartEvent/types'
import { fetchUser } from './utils/fetchUser'
import { getLocationHeaders } from './utils/getLocationHeaders'

Sentry.init()

smoothscroll.polyfill()

const dorisIsolatedClass = 'doris-widget-isolated'

const init = async config => {
  dorisLog('MIX instance started')

  checkIfHasDeprecatedStorage()

  const allDorisWidgets = Array.from(document.querySelectorAll('#doris-widget'))

  const fallbackWidgets = allDorisWidgets.filter(el => el.getAttribute('data-fallback'))
  const partnerWidgets = allDorisWidgets.filter(el => !el.getAttribute('data-fallback'))
  if (partnerWidgets.length === 0) {
    dorisLog('Container for the Widget not found.')
    dorisLog('Creating element.')
    const widgetDiv = document.createElement('div')
    widgetDiv.id = 'doris-widget'
    widgetDiv.setAttribute('data-fallback', true)
    document.body.prepend(widgetDiv)
  }
  fallbackWidgets.forEach(el => el.remove())
  if (partnerWidgets.length > 1) {
    partnerWidgets.forEach((el, index) => {
      if (index) el.remove()
    })
  }

  const rootElement = document.getElementById('doris-widget')

  if (!config.apiKey) {
    // eslint-disable-next-line
    console.error('[DORIS][INIT] O parâmetro "apiKey" é obrigatório')

    Sentry.captureException({
      errorName: 'UNDEFINED_API_KEY',
      errorMessage: 'O parâmetro "apiKey" é obrigatório',
      filePath: 'src/index.js',
      functionName: 'init',
      payload: config,
    })
    return
  }

  localStorage.setItem('@doris:partner_apikey', config.apiKey)

  fetchUrlParameters()

  await fetchUser()
  await getLocationHeaders()

  const { splashImage = '', totemExperience = false, position, language } = config

  if (position?.x) {
    theme.position.x = config.position.x
  }

  localStorage.setItem(
    '@doris:config',
    JSON.stringify({
      splash_image: splashImage,
      totem_experience: totemExperience,
      widget_position: position?.x ? position.x : 'left',
      language: validateAndParseLanguage(language || document.documentElement.lang),
    }),
  )

  Tracking.init()

  handleABTests()

  theme.colors.primary = config.theme?.colors?.primary || theme.colors.primary

  if (!rootElement) return

  rootElement.classList.add(dorisIsolatedClass)

  HandleGoToCartInstance.set({ ref: config.handleGoToCartButton })

  ReactDOM.render(
    <React.StrictMode>
      <App handleBuyButton={config.handleBuyButton} />
    </React.StrictMode>,
    rootElement,
  )
}

const start = settings => {
  const event = DorisStartEvent.create(EOrigin.Start, settings)

  if (event) {
    document.dispatchEvent(event)
  }
}

const order = async dataOrder => {
  if (!validationsDataOrder(dataOrder)) return

  await captureOrderEvent({
    appuser: dataOrder.appuser,
    orderId: dataOrder.id,
    products: dataOrder.products,
    total: dataOrder.value,
    currency: dataOrder.currency,
  })
}

export { init, verify, start, order, injectButton }
